import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12.02 12.02" {...props}><path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M12.02.004v8.99h-.996v-7.3L.698 12.024 0 11.294 10.293.994H2.989v-.99z" /></svg>;
export default Component;